var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSandClockOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7195 72.2C22.7195 72.2 15.2555 56.368 34.9515 43.92C34.9515 43.92 38.0075 42.08 38.0075 40C38.0075 37.92 34.9515 36.08 34.9515 36.08C15.2555 23.632 22.7195 7.80005 22.7195 7.80005",
    stroke: "#E22A1F",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4013 1.99994H59.6013C59.9323 1.99994 60.2497 2.13142 60.4838 2.36547C60.7178 2.59952 60.8493 2.91695 60.8493 3.24794V7.79994H19.1533V3.24794C19.1533 2.91695 19.2848 2.59952 19.5189 2.36547C19.7529 2.13142 20.0703 1.99994 20.4013 1.99994Z",
    stroke: "#E22A1F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1533 72.2H60.8493V76.752C60.8493 77.0829 60.7178 77.4004 60.4838 77.6344C60.2497 77.8685 59.9323 78 59.6013 78H20.4013C20.0703 78 19.7529 77.8685 19.5189 77.6344C19.2848 77.4004 19.1533 77.0829 19.1533 76.752V72.2Z",
    stroke: "#E22A1F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2802 72.2C57.2802 72.2 64.7442 56.368 45.0482 43.92C45.0482 43.92 41.9922 42.08 41.9922 40C41.9922 37.92 45.0482 36.08 45.0482 36.08C64.7442 23.632 57.2802 7.80005 57.2802 7.80005",
    stroke: "#E22A1F",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2795 72.2C57.2795 72.2 64.7435 56.368 45.0475 43.92C45.0475 43.92 41.9915 42.08 41.9915 40C41.9915 37.92 45.0475 36.08 45.0475 36.08C64.7435 23.632 57.2795 7.80005 57.2795 7.80005H22.7195C22.7195 7.80005 15.2555 23.632 34.9515 36.08C34.9515 36.08 38.0075 37.92 38.0075 40C38.0075 42.08 34.9515 43.92 34.9515 43.92C15.2555 56.368 22.7195 72.2 22.7195 72.2H57.2795Z",
    stroke: "#E22A1F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9038 62.3279C45.1235 60.0666 34.9561 60.0666 25.1758 62.3279",
    stroke: "#E22A1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3359 20.696C30.0319 23.856 32.1919 27.688 37.7199 31.184C38.583 31.7231 39.353 32.3985 39.9999 33.184C40.6458 32.4019 41.4161 31.7316 42.2799 31.2C47.8159 27.696 49.9679 23.864 50.6719 20.696",
    stroke: "#E22A1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandClockOutlined);
export default __webpack_public_path__ + "static/media/sand_clock_outlined.aa3340cf.svg";
export { ForwardRef as ReactComponent };